<template>
  <div class="index">
    <div class="select">
      <van-search v-model="serchVale" shape="round" placeholder="搜索" @search="search" @clear="clear" />
      <van-icon v-if="sreenw" @click="routerPusht" style="font-size: var(--base-px-20)" name="filter-o" />
    </div>

    <van-tabs v-model="actives" title-active-color="#FFFFFF" title-inactive-color="#FFFFFF" color="#FFFFFF"
      background="#245DC4">
      <van-tab title="客户">
        <div class="customer">
          <div v-if="!serchT">
            <div class="total" style="
                font-weight: 550;
                display: flex;
                align-items: center;
                justify-content: space-between;
              ">
              共{{ pages.total }}个客户
              <div v-if="is_label">
                <a v-if="userDatalt.isDealer" style="font-weight: normal;margin-right: var(--base-px-10);"
                  @click="showLabelPhpop">标签管理</a>
                <a @click="checkMode = true" v-if="!userDatalt.isDealer && !checkMode"
                  style="font-weight: normal">批量打标签</a>
                <a @click="checkMode = false" v-else-if="!userDatalt.isDealer" style="font-weight: normal">取消</a>
              </div>
            </div>
            <div class="nav">
              <div class="nav-item" v-for="(item, index) in list" :key="index" @click="onSelectedChange(index)"
                :class="[index == currindex ? 'nav-active' : '']">
                {{ item.status }}
              </div>
            </div>
            <div class="label-list" v-if="is_label">
              <div class="user-label">
                <div class="label-item" v-for="(item, index) in labelList" :key="index" @click="onChangeLabel(index)"
                  :class="index == labelIndex ? 'label-item-active' : ''">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <!-- Tab/标签切换加载动画 -->
            <div v-if="tabLoading || labelLoading" class="tab-loading">
              <van-loading type="spinner" size="40px">加载中...</van-loading>
            </div>
            <div v-else class="list">
              <van-checkbox-group icon-size="15px" v-model="resultCustomer" ref="checkboxGroup">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                  <div :class="{
                    choseItem: resultCustomer.indexOf(index) != -1,
                  }" style="
                      margin-top: var(--base-px-10);
                      border-radius: var(--base-px-7);
                      border: var(--base-px-1) solid transparent;
                    " v-for="(item, index) in userList" :key="index">
                    <div @click="userDetails(item)" class="list-item">
                      <div class="layout-side w-full">
                        <img @click="routerPush(item)" class="avater" :src="item.avatar" alt="" />
                        <div @click="routerPush(item)" class="mindel">
                          <div class="item">
                            <div style="display: flex">
                              <h4>
                                {{ item.nickname }}
                              </h4>
                              <span>@微信</span>
                              <span>（ID：{{ item.id }}）</span>
                            </div>
                            <div>
                              <div>注册时间：{{ item.create_time }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="layout-center-v">
                          <div class="layout-center" style="height: var(--base-px-32)">
                            <div style="
                                font-size: var(--base-px-12);
                                width: var(--base-px-60);
                              " v-if="item.is_register === 0">
                              <img style="
                                  width: var(--base-px-16);
                                  height: var(--base-px-16);
                                  margin-right: var(--base-px-4);
                                " src="../../assets/contact/3.png" />未注册
                            </div>
                            <div style="
                                font-size: var(--base-px-12);
                                width: var(--base-px-60);
                              " v-else>
                              <img style="
                                  width: var(--base-px-16);
                                  height: var(--base-px-16);
                                  margin-right: var(--base-px-4);
                                " src="../../assets/contact/4.png" />已注册
                            </div>
                          </div>
                          <div class="layout-center" style="height: var(--base-px-32)">
                            <van-checkbox v-if="checkMode" :name="item"></van-checkbox>
                          </div>
                        </div>
                      </div>
                      <!-- 标签展示 -->
                      <div v-if="item.tags && item.tags.length > 0&&is_label" class="user-tags">
                        <van-tag v-for="tag in item.tags" :key="tag.id" type="primary" size="medium" plain>
                          {{ tag.name }}
                        </van-tag>
                      </div>
                      <div class="w-full layout-side" style="
                          margin-top: var(--base-px-8);
                          font-size: var(--base-px-13);
                        ">
                        <div>
                          所属客服：
                          {{ item.employeeName }}
                        </div>
                        <div v-if="item.status == 1 && !isDealer" class="forbidden layout-center" style="color: #f50f0f"
                          @click="onForbiddenChange(item, true)">
                          <img style="
                              width: var(--base-px-16);
                              height: var(--base-px-16);
                              margin-right: var(--base-px-4);
                            " src="../../assets/contact/1.png" />禁用
                        </div>
                      </div>
                      <div class="w-full layout-side" style="
                          margin-top: var(--base-px-8);
                          font-size: var(--base-px-13);
                        ">
                        <div>
                          看课天数：
                          {{ item.like_course_day_number }}
                        </div>
                      </div>
                      <div class="w-full layout-side" style="
                          margin-top: var(--base-px-8);
                          font-size: var(--base-px-13);
                        ">
                        <div >
                          看课数量：{{ item.like_course_number }}
                        </div>
                      </div>
                      <div class="w-full layout-side" style="
                          margin-top: var(--base-px-12);
                          font-size: var(--base-px-14);
                        ">
                        <div v-if="item.day_watck_course === 0" class="layout-center" style="
                            width: 33.33%;
                            border-right: var(--base-px-1) solid #dbdbdb;
                            color: red;
                            font-size: var(--base-px-13);
                          ">
                          今日未看课
                        </div>
                        <div v-if="item.day_watck_course === 1" class="layout-center" style="
                            width: 33.33%;
                            border-right: var(--base-px-1) solid #dbdbdb;
                            color: #1a89f9;
                            font-size: var(--base-px-13);
                          ">
                          今日已看课
                        </div>
                        <div v-if="item.day_watck_course === 2" class="layout-center" style="
                            width: 33.33%;
                            border-right: var(--base-px-1) solid #dbdbdb;
                            color: #5ec75d;
                            font-size: var(--base-px-13);
                          ">
                          今日已完播
                        </div>
                        <div class="layout-center" style="
                            width: 33.33%;
                            border-right: var(--base-px-1) solid #dbdbdb;
                            font-size: var(--base-px-13);
                          ">
                          参与营期&nbsp;{{ item.watch_class_number || 0 }}
                        </div>
                        <div class="layout-center" style="width: 33.33%; font-size: var(--base-px-13)">
                          缺课数量&nbsp;{{ item.lack_class_number || 0 }}
                        </div>
                      </div>
                      <div class="chat">
                        <div class="chat-right" @click="goShareKe(item.id)">
                          <img src="../../assets/course/2.png" alt="" />
                          分享
                        </div>
                        <div v-if="!userDatalt.isDealer&&is_label" style="margin-left: var(--base-px-10);" class="chat-right"
                          @click="editLabel(item)">
                          编辑标签
                        </div>
                          <div v-if="!userDatalt.isDealer"  class="chat-right" style="margin-left: var(--base-px-10);" @click="copyH5Link(item)">
                              获取看课链接
                          </div>
                      </div>
                    </div>
                  </div>
                </van-list>
              </van-checkbox-group>
            </div>
          </div>
          <div v-else>
            <div class="total" style="
                font-weight: 550;
                display: flex;
                align-items: center;
                justify-content: space-between;
              ">
              共{{ serListp.total }}个客户
              <a @click="checkMode = true" v-if="!checkMode&&is_label" style="font-weight: normal">批量打标签</a>
              <a @click="checkMode = false" v-else-if="is_label" style="font-weight: normal">取消</a>
            </div>
            <div class="list">
              <van-checkbox-group icon-size="15px" v-model="resultCustomer" ref="checkboxGroup">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                  <div :class="{
                    choseItem: resultCustomer.indexOf(index) != -1,
                  }" style="
                      margin-top: var(--base-px-10);
                      border-radius: var(--base-px-7);
                      border: var(--base-px-1) solid transparent;
                    " v-for="(item, index) in serList" :key="index">
                    <div class="list-item">
                      <div class="layout-side w-full">
                        <img @click="routerPush(item)" class="avater" :src="item.avatar" alt="" />
                        <div @click="routerPush(item)" class="mindel">
                          <div class="item">
                            <div style="display: flex">
                              <h4>
                                {{ item.name }}
                              </h4>
                              <span>@微信</span>
                            </div>
                            <div>
                              <div>注册时间：{{ item.create_time }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="layout-center-v">
                          <div class="layout-center" style="height: var(--base-px-32)">
                            <div style="
                                font-size: var(--base-px-12);
                                width: var(--base-px-60);
                              " v-if="item.is_register === 0">
                              <img style="
                                  width: var(--base-px-16);
                                  height: var(--base-px-16);
                                  margin-right: var(--base-px-4);
                                " src="../../assets/contact/3.png" />未注册
                            </div>
                            <div style="
                                font-size: var(--base-px-12);
                                width: var(--base-px-60);
                              " v-else>
                              <img style="
                                  width: var(--base-px-16);
                                  height: var(--base-px-16);
                                  margin-right: var(--base-px-4);
                                " src="../../assets/contact/4.png" />已注册
                            </div>
                          </div>
                          <div class="layout-center" style="height: var(--base-px-32)">
                            <van-checkbox v-if="checkMode" :name="item"></van-checkbox>
                          </div>
                        </div>
                      </div>
                      <!-- 标签展示 -->
                      <div v-if="item.tags && item.tags.length > 0&&is_label" class="user-tags">
                        <van-tag v-for="tag in item.tags" :key="tag.id" type="primary" size="medium" plain>
                          {{ tag.name }}
                        </van-tag>
                      </div>
                      <div class="w-full layout-side" style="
                          margin-top: var(--base-px-12);
                          font-size: var(--base-px-13);
                        ">
                        <div>
                          所属客服：
                          {{ item.employeeName }}
                        </div>
                        <div v-if="!isDealer" class="forbidden layout-center" style="color: #f50f0f"
                          @click="onForbiddenChange(item, true)">
                          <img style="
                              width: var(--base-px-16);
                              height: var(--base-px-16);
                              margin-right: var(--base-px-4);
                            " src="../../assets/contact/1.png" />禁用
                        </div>
                      </div>
                      <div class="w-full layout-side" style="
                          margin-top: var(--base-px-12);
                          font-size: var(--base-px-14);
                        ">
                        <div v-if="item.day_watck_course == 0" class="layout-center" style="
                            width: 33.33%;
                            border-right: var(--base-px-1) solid #dbdbdb;
                            color: red;
                            font-size: var(--base-px-13);
                          ">
                          今日未看课
                        </div>
                        <div v-if="item.day_watck_course == 1" class="layout-center" style="
                            width: 33.33%;
                            border-right: var(--base-px-1) solid #dbdbdb;
                            color: #1a89f9;
                            font-size: var(--base-px-13);
                          ">
                          今日已看课
                        </div>
                        <div v-if="item.day_watck_course == 2" class="layout-center" style="
                            width: 33.33%;
                            border-right: var(--base-px-1) solid #dbdbdb;
                            color: #5ec75d;
                            font-size: var(--base-px-13);
                          ">
                          今日已完播
                        </div>

                        <div class="layout-center" style="
                            width: 33.33%;
                            border-right: var(--base-px-1) solid #dbdbdb;
                            font-size: var(--base-px-13);
                          ">
                          参与营期&nbsp;{{ item.watch_class_number || 0 }}
                        </div>
                        <div class="layout-center" style="width: 33.33%; font-size: var(--base-px-13)">
                          缺课数量&nbsp;{{ item.lack_class_number || 0 }}
                        </div>
                      </div>
                    </div>
                  </div>
                </van-list>
              </van-checkbox-group>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="待审核">
        <div class="customer">
          <div v-if="!serchT">
            <div class="total" style="
                font-weight: 550;
                display: flex;
                align-items: center;
                justify-content: space-between;
              ">
              共{{ pages.total }}个客户
            </div>
            <!-- Tab切换加载动画 -->
            <div v-if="tabLoading" class="tab-loading">
              <van-loading type="spinner" size="40px">加载中...</van-loading>
            </div>
            <div v-else class="list">
              <van-checkbox-group icon-size="15px" v-model="resultCustomer" ref="checkboxGroup">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                  <div :class="{
                    choseItem: resultCustomer.indexOf(index) != -1,
                  }" style="
                      margin-top: 10px;
                      border-radius: 7px;
                      border: 1px solid transparent;
                    " v-for="(item, index) in userList" :key="index">
                    <div @click="userDetails(item)" class="list-item">
                      <div class="layout-side w-full">
                        <img @click="routerPush(item)" class="avater" :src="item.avatar" alt="" />
                        <div @click="routerPush(item)" class="mindel">
                          <div class="item">
                            <div style="display: flex">
                              <h4>
                                {{ item.name }}
                              </h4>
                              <span>@微信</span>
                              <span>（ID：{{ item.id }}）</span>
                            </div>
                            <div>
                              <div>注册时间：{{ item.create_time }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="!isDealer" class="bottom layout-side audit-button" style="font-size: 14px">
                      <div class="layout-center" @click="onAuditChange(item, false)"
                        style="width: 50%; border-right: 1px solid #dbdbdb">
                        拒绝
                      </div>
                      <div class="layout-center" @click="onAuditChange(item, true)"
                        style="width: 50%; border-left: 1px solid #dbdbdb">
                        审核
                      </div>
                    </div>
                  </div>
                </van-list>
              </van-checkbox-group>
            </div>
          </div>
          <div v-else>
            <div class="list">
              <van-checkbox-group icon-size="15px" v-model="resultCustomer" ref="checkboxGroup">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                  <div :class="{
                    choseItem: resultCustomer.indexOf(index) != -1,
                  }" style="
                      margin-top: 10px;
                      border-radius: 7px;
                      border: 1px solid transparent;
                    " v-for="(item, index) in serList" :key="index">
                    <div class="list-item">
                      <div class="layout-side w-full">
                        <img @click="routerPush(item)" class="avater" :src="item.avatar" alt="" />
                        <div @click="routerPush(item)" class="mindel">
                          <div class="item">
                            <div style="display: flex">
                              <h4>
                                {{ item.name }}
                              </h4>
                              <span>@微信</span>
                            </div>
                            <div>
                              <div>注册时间：{{ item.create_time }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="!isDealer" class="bottom layout-side audit-button" style="font-size: 14px">
                      <div class="layout-center" @click="onAuditChange(item, false)"
                        style="width: 50%; border-right: 1px solid #dbdbdb">
                        拒绝
                      </div>
                      <div class="layout-center" @click="onAuditChange(item, true)"
                        style="width: 50%; border-left: 1px solid #dbdbdb">
                        审核
                      </div>
                    </div>
                  </div>
                </van-list>
              </van-checkbox-group>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="小黑屋">
        <div class="customer">
          <div v-if="!serchT">
            <div class="total" style="
                font-weight: 550;
                display: flex;
                align-items: center;
                justify-content: space-between;
              ">
              共{{ pages.total }}个客户
            </div>
            <!-- Tab切换加载动画 -->
            <div v-if="tabLoading" class="tab-loading">
              <van-loading type="spinner" size="40px">加载中...</van-loading>
            </div>
            <div v-else class="list">
              <van-checkbox-group icon-size="15px" v-model="resultCustomer" ref="checkboxGroup">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                  <div :class="{
                    choseItem: resultCustomer.indexOf(index) !== -1,
                  }" style="
                      margin-top: var(--base-px-10);
                      border-radius: var(--base-px-7);
                      border: var(--base-px-1) solid transparent;
                    " v-for="(item, index) in userList" :key="index">
                    <div class="list-item">
                      <div class="layout-side w-full">
                        <img @click="routerPush(item)" class="avater" :src="item.avatar" alt="" />
                        <div @click="routerPush(item)" class="mindel">
                          <div class="item">
                            <div style="display: flex">
                              <h4>
                                {{ item.name }}
                              </h4>
                              <span>@微信</span>
                              <span>（ID：{{ item.id }}）</span>
                            </div>
                            <div>
                              <div>注册时间：{{ item.create_time }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="layout-center-v">
                          <div style="height: var(--base-px-32)">
                            <div style="
                                font-size: var(--base-px-12);
                                width: var(--base-px-60);
                              " v-if="item.is_register === 0">
                              <img style="
                                  width: var(--base-px-16);
                                  height: var(--base-px-16);
                                  margin-right: var(--base-px-4);
                                " src="../../assets/contact/3.png" />未注册
                            </div>
                            <div style="
                                font-size: var(--base-px-12);
                                width: var(--base-px-60);
                              " v-else>
                              <img style="
                                  width: var(--base-px-16);
                                  height: var(--base-px-16);
                                  margin-right: var(--base-px-4);
                                " src="../../assets/contact/4.png" />已注册
                            </div>
                          </div>
                          <div class="layout-center" style="height: var(--base-px-41)">
                            <van-checkbox v-if="checkMode" :name="item"></van-checkbox>
                          </div>
                        </div>
                      </div>
                      <!-- 标签展示 -->
                      <div v-if="item.tags && item.tags.length > 0" class="user-tags">
                        <van-tag v-for="tag in item.tags" :key="tag.id" type="primary" size="medium" plain>
                          {{ tag.name }}
                        </van-tag>
                      </div>
                      <div class="w-full layout-side" style="
                          margin-top: var(--base-px-12);
                          font-size: var(--base-px-14);
                        ">
                        <div>
                          所属客服：
                          {{ item.employeeName }}
                        </div>
                        <div v-if="!isDealer" class="forbidden layout-center" style="color: #13bb1e"
                          @click="onForbiddenChange(item, false)">
                          <img style="
                              width: var(--base-px-16);
                              height: var(--base-px-16);
                              margin-right: var(--base-px-4);
                            " src="../../assets/contact/2.png" />解除
                        </div>
                      </div>
                    </div>
                  </div>
                </van-list>
              </van-checkbox-group>
            </div>
          </div>
          <div v-else>
            <div class="list">
              <van-checkbox-group icon-size="15px" v-model="resultCustomer" ref="checkboxGroup">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                  <div :class="{
                    choseItem: resultCustomer.indexOf(index) != -1,
                  }" style="
                      margin-top: var(--base-px-10);
                      border-radius: var(--base-px-7);
                      border: var(--base-px-1) solid transparent;
                    " v-for="(item, index) in serList" :key="index">
                    <div class="list-item">
                      <div class="layout-side w-full">
                        <img @click="routerPush(item)" class="avater" :src="item.avatar" alt="" />
                        <div @click="routerPush(item)" class="mindel">
                          <div class="item">
                            <div style="display: flex">
                              <h4>
                                {{ item.name }}
                              </h4>
                              <span>@微信</span>
                            </div>
                            <div>
                              <div>注册时间：{{ item.create_time }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="layout-center-v">
                          <div style="height: var(--base-px-32)">
                            <div style="
                                font-size: var(--base-px-12);
                                width: var(--base-px-60);
                              " v-if="item.is_register === 0">
                              <img style="
                                  width: var(--base-px-16);
                                  height: var(--base-px-16);
                                  margin-right: var(--base-px-4);
                                " src="../../assets/contact/3.png" />未注册
                            </div>
                            <div style="
                                font-size: var(--base-px-12);
                                width: var(--base-px-60);
                              " v-else>
                              <img style="
                                  width: var(--base-px-16);
                                  height: var(--base-px-16);
                                  margin-right: var(--base-px-4);
                                " src="../../assets/contact/4.png" />已注册
                            </div>
                          </div>
                          <div class="layout-center" style="height: var(--base-px-41)">
                            <van-checkbox v-if="checkMode" :name="item"></van-checkbox>
                          </div>
                        </div>
                      </div>
                      <!-- 标签展示 -->
                      <div v-if="item.tags && item.tags.length > 0" class="user-tags">
                        <van-tag v-for="tag in item.tags" :key="tag.id" type="primary" size="medium" plain>
                          {{ tag.name }}
                        </van-tag>
                      </div>
                      <div class="w-full layout-side" style="
                          margin-top: var(--base-px-12);
                          font-size: var(--base-px-14);
                        ">
                        <div>
                          所属客服：
                          {{ item.employeeName }}
                        </div>
                        <div v-if="!isDealer" class="forbidden layout-center" style="color: #13bb1e"
                          @click="onForbiddenChange(item, false)">
                          <img style="
                              width: var(--base-px-16);
                              height: var(--base-px-16);
                              margin-right: var(--base-px-4);
                            " src="../../assets/contact/2.png" />解除
                        </div>
                      </div>
                    </div>
                  </div>
                </van-list>
              </van-checkbox-group>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="重粉">
        <div class="customer">
          <div v-if="!serchT">
            <div class="total" style="
                font-weight: 550;
                display: flex;
                align-items: center;
                justify-content: space-between;
              ">
              共{{ heavyPage.total }}个客户
              <!--							<a @click="synchronizationRepeat()" style="font-weight: normal">同步</a>-->
            </div>
            <!-- Tab切换加载动画 -->
            <div v-if="tabLoading" class="tab-loading">
              <van-loading type="spinner" size="40px">加载中...</van-loading>
            </div>
            <div v-else class="list">
              <van-checkbox-group icon-size="15px" v-model="resultCustomer" ref="checkboxGroup">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                  <div :class="{
                    choseItem: resultCustomer.indexOf(index) != -1,
                  }" style="
                      margin-top: var(--base-px-10);
                      border-radius: var(--base-px-7);
                      border: var(--base-px-1) solid transparent;
                    " v-for="(item, index) in heavyList" :key="index">
                    <div class="list-item">
                      <div class="layout-side w-full">
                        <img class="avater" :src="item.avatar" alt="" />
                        <div class="mindel">
                          <div class="item">
                            <div style="display: flex">
                              <h4>
                                {{ item.nickname }}
                              </h4>
                              <span>@微信</span>
                              <span>（ID：{{ item.id }}）</span>
                            </div>
                            <div>
                              <div>
                                注册时间：{{ item.create_time | formatDate }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </van-list>
              </van-checkbox-group>
            </div>
          </div>
          <div v-else>
            <div class="list">
              <van-checkbox-group icon-size="15px" v-model="resultCustomer" ref="checkboxGroup">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                  <div :class="{
                    choseItem: resultCustomer.indexOf(index) != -1,
                  }" style="
                      margin-top: var(--base-px-10);
                      border-radius: var(--base-px-7);
                      border: var(--base-px-1) solid transparent;
                    " v-for="(item, index) in serList" :key="index">
                    <div class="list-item">
                      <div class="layout-side w-full">
                        <img class="avater" :src="item.avatar" alt="" />
                        <div class="mindel">
                          <div class="item">
                            <div style="display: flex">
                              <h4>
                                {{ item.name }}
                              </h4>
                              <span>@微信</span>
                            </div>
                            <div>
                              <div>注册时间：{{ item.create_time }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </van-list>
              </van-checkbox-group>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <!--  多选操作  -->
    <div v-if="checkMode">
      <div class="select-all contact-select-all">
        <van-checkbox v-model="selectAll" icon-size="15px">全选</van-checkbox>
        <span class="length">已选择{{ resultCustomer.length }}个客户</span>
        <van-button @click="openLabelSelector" style="height: var(--base-px-31)" type="info">
          打标签
        </van-button>
      </div>
    </div>
    <!--  添加标签  -->
    <managementLabel ref="managementLabel" @refresh="handleLabelRefresh" />
    <van-tabbar v-model="active" class="tab">
      <van-tabbar-item replace to="/">
        <span>首页</span>
        <template #icon="props">
          <img v-if="props.active" src="../../assets/images/home.png" />
          <img v-else src="../../assets/images/home-active.png" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/course/index" icon="search">
        <span>课程</span>
        <template #icon="props">
          <img v-if="props.active" src="../../assets/images/course-active.png" />
          <img v-else src="../../assets/images/course.png" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/customer" icon="search">
        <span>客户</span>
        <template #icon="props">
          <img v-if="props.active" src="../../assets/images/customer-active.png" />
          <img v-else src="../../assets/images/customer.png" />
        </template>
      </van-tabbar-item>
      <!--			<van-tabbar-item replace to="/tool/index" icon="setting-o">-->
      <!--				<span>运营工具</span>-->
      <!--				<template #icon="props">-->
      <!--					<img v-if="props.active" src="../../assets/images/function-active.png" />-->
      <!--					<img v-else src="../../assets/images/function.png">-->
      <!--				</template>-->
      <!--			</van-tabbar-item>-->
      <van-tabbar-item replace :to="userDatalt.isDealer ? '/my' : '/my?id=' + userDatalt.id" icon="setting-o">
        <span>{{ userDatalt.isDealer ? "我的" : "直播课" }}</span>
        <template #icon="props">
          <img v-if="props.active" src="../../assets/images/my-active.png" />
          <img v-else src="../../assets/images/my.png" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item v-if="!userDatalt.isDealer && is_live" replace to="/live/index" icon="search">
        <span>直播</span>
        <template #icon="props">
          <img v-if="props.active" src="../../assets/images/live-active.png" />
          <img v-else src="../../assets/images/live.png">
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <customerLabel ref="customerLabel" @success="handleLabelBindSuccess" />
  </div>
</template>

<script>
import managementLabel from "./components/managementLabel";
import {
  batchCreateContactTag,
  contactIndex,
  blackRoomList,
  pendingReviewList,
  workRoom,
  disableContact,
  enableContact,
  reviewContact,
  synchronizationRepeat,
  repeatList,
} from "../../api/customer";
import customerLabel from "./components/customerLabel";
import Clipboard from "clipboard";
import { Dialog, Toast } from "vant";
import { userCenter } from "@/api/homePage";
import { openEnterpriseChat } from "@/utils/wxCodeAuth";
import { getTagListAll } from "@/api/channelCode";

export default {
  components: {
    customerLabel,
    managementLabel
  },
  data() {
    return {
      // 文字
      message: "",
      // tbas切换
      tabsChose: 0,
      actives: 0,
      active: 2,
      // 搜索条件
      serchVale: "",
      // 客户
      resultCustomer: [],
      checkMode: false,
      // 全选
      selectAll: "",
      // 列表加载
      loading: false,
      finished: false,
      tabLoading: false, // tab切换加载状态
      labelLoading: false, // 标签切换加载状态
      page: 1,
      userList: [],
      pages: {
        perPage: "",
        total: "",
        totalPage: "",
      },
      tagsValue: [],

      dataLiS: {
        page: "",
        perPage: "",
      },
      serList: [],
      serchT: false,
      serListp: {},

      // 客户群
      baseList: [],
      sreenw: true,
      userDatalt: {
        name: "",
      },
      list: [
        {
          status: "全部",
        },
        /*{
            status: '今日新增'
          },*/
        {
          status: "今日注册",
        },
        {
          status: "今日完播",
        },
        {
          status: "今日未观看",
        },
      ],
      currindex: 0,
      isDealer: 0,
      heavyList: [],
      heavyPage: {
        perPage: "",
        total: "",
        totalPage: "",
      },
      is_live: process.env.VUE_APP_IS_LIVE === 'false' ? false : true,
      is_label: process.env.VUE_APP_IS_LABEL == '1' ? true : false,
      labelIndex: 0,
      labelList: [],
    };
  },
  watch: {
    selectAll(e) {
      if (e) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll();
      }
    },
    actives(e) {
      // 设置tab切换加载状态
      this.tabLoading = true;
      this.userList = [];
      this.page = 1;
      this.finished = false;

      if (this.actives === 0) {
        this.sreenw = true;
        this.serchVale = "";
        this.getContactIndex();
      } else if (this.actives === 1) {
        this.sreenw = false;
        this.serchVale = "";
        this.getPendingReviewList();
      } else if (this.actives === 2) {
        this.sreenw = false;
        this.serchVale = "";
        this.getBlackRoomList();
      } else if (this.actives === 3) {
        this.sreenw = false;
        this.serchVale = "";
        this.getRepeatList();
      } else {
        this.sreenw = true;
        this.tabLoading = false;
      }
    },
    serchVale() {
      if (!this.serchVale) {
        this.clear();
      }
    },
  },
  filters: {
    formatDate(time) {
      if (!time) return "";
      const date = new Date(time * 1000); // 如果时间戳是以秒为单位的，乘以1000转换为毫秒
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1，并确保两位数
      const day = ("0" + date.getDate()).slice(-2); // 确保两位数
      const hours = ("0" + date.getHours()).slice(-2); // 确保两位数
      const minutes = ("0" + date.getMinutes()).slice(-2); // 确保两位数
      const seconds = ("0" + date.getSeconds()).slice(-2); // 确保两位数
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
  created() {
    console.log('is_live', this.is_live);
    console.log(typeof this.is_live);
    this.customerBase();
    if (this.$route.query.content) {
      this.dataLiS = JSON.parse(this.$route.query.content);
      if (this.dataLiS && this.dataLiS.tags) {
        let tags = "";
        this.dataLiS.tags.forEach((item) => {
          tags += item.id + ",";
        });
        tags = tags.slice(0, tags.length - 1);
        this.dataLiS.tagss = this.dataLiS.tags;
        this.dataLiS.tags = tags;
      }
    }
    const item = JSON.parse(localStorage.getItem("userDetails"));
    if (item) {
      this.userDatalt = item;
      this.isDealer = item.role == 1;
    }

    this.getTagListAll();


    // userCenter().then(res => {
    // 	this.userDatalt = res.data.baseInfo
    // 	if (!item) {
    // 		localStorage.setItem("userDetails", JSON.stringify(this.userDatalt))
    // 	} else if (item.id !== this.userDatalt.id) {
    // 		localStorage.setItem("userDetails", JSON.stringify(this.userDatalt))
    // 	}
    // })
  },
  methods: {
    editLabel(item) {
      // 传入用户对象进行编辑
      this.$refs.customerLabel.$show(item);
    },
    getTagListAll() {
      if (!this.is_label) {
        return
      }
      getTagListAll().then(res => {
        console.log(res);
        if (res.code === 1) {
          this.labelList = [{
            name: '全部',
            id: -1
          }, ...res.data];
        }
      });
    },
    showLabelPhpop() {
      this.$refs.managementLabel.$show();
    },
    // 标签管理刷新回调
    handleLabelRefresh() {
      console.log('标签管理刷新，更新标签列表');
      // 刷新标签列表
      this.getTagListAll();
    },
    onChangeLabel(index) {
      // 设置标签切换加载状态
      this.labelLoading = true;
      this.labelIndex = index;
      this.userList = [];
      this.page = 1;
      this.finished = false;
      this.getContactIndex();
    },
    goShareKe(id) {
      this.$router.push({
        path: "/contact/course",
        query: {
          contactId: id,
        },
      });
    },
    copyH5Link(item) {
      const link = `长按复制链接，用浏览器打开  ${item.kanke_h5_browser_url}?param=${item.unionid}&app_no=${item.app_no}`;
      const input = document.createElement('input');
      input.value = link;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$toast.success('复制成功');
    },
    onSelectedChange(index) {
      this.sreenw = true;
      this.serchVale = "";
      this.userList = [];
      this.page = 1;

      this.currindex = index;
      this.dataLiS = {
        page: "",
        perPage: "",
      };
      /*if (this.currindex == 1) {
          this.dataLiS.startTime = this.gettiem();
          this.dataLiS.endTime = this.gettiem1();
        } else*/
      if (this.currindex == 1) {
        this.dataLiS.start_registration_time = this.gettiem();
        this.dataLiS.end_registration_time = this.gettiem1();
      } else if (this.currindex == 2) {
        this.dataLiS.watchLessonStatus = 2;
      } else if (this.currindex == 3) {
        this.dataLiS.watchLessonStatus = 0;
      }
      this.getContactIndex();
    },
    onForbiddenChange(item, flag) {
      // if (item.is_register === 0) {
      // 	Toast('该用户未注册，不能禁用~');
      // 	return
      // }
      let _this = this;
      Dialog.confirm({
        message: `是否${flag ? "禁用该用户" : "解除该客户的禁用状态"}`,
      }).then(() => {
        if (flag) {
          disableContact({
            contact_id: item.id,
          }).then((res) => {
            if (res.code === 1) {
              Toast("已成功禁用~");
              let index = this.userList.findIndex(
                (items) => items.id == item.id
              );
              this.userList.splice(index, 1);
              if (this.page < 3) {
                this.page = 1;
                this.onLoad();
              }
            }
          });
        } else {
          console.log(item);
          enableContact({
            contact_id: item.id,
          }).then((res) => {
            if (res.code === 1) {
              Toast("已成功解除禁用~");
              let index = this.userList.findIndex(
                (items) => items.id == item.id
              );
              this.userList.splice(index, 1);
              if (this.page < 3) {
                this.page = 1;
                this.onLoad();
              }
            }
          });
        }
      });
    },
    //同步重粉
    synchronizationRepeat() {
      synchronizationRepeat({}).then((res) => {
        console.log(res);
        console.log("1111");
        if (res.code === 1) {
          Toast("同步成功~");
        } else {
          Toast("同步失败~");
        }
        this.getRepeatList();
      });
    },

    onAuditChange(item, flag) {
      console.log(item, flag);
      Dialog.confirm({
        message: `是否${flag ? "同意" : "拒绝"}该客户的审核申请`,
      }).then(() => {
        reviewContact({
          contact_id: item.id,
          type: flag,
        })
          .then((res) => {
            if (res.code === 200) {
              Toast(flag ? "已通过客户申请" : "已拒绝客户申请");
            }
          })
          .finally(() => {
            this.getPendingReviewList();
          });
      });
    },
    routerPush(item) {
      /*this.$router.push({
          path: '/contact/detail',
          query: {
            contactId: item.id
          }
        })*/
    },
    routerPusht() {
      this.$router.push({
        path: "/contact/screen",
        query: {
          content: JSON.stringify(this.dataLiS),
        },
      });
    },
    // 打开标签选择器
    openLabelSelector() {
      if (this.resultCustomer.length === 0) {
        this.$toast.fail('请先选择客户');
        return;
      }

      // 获取选中的用户ID数组
      const userIds = this.resultCustomer.map((i) => i.id);

      // 打开标签选择弹窗，传入用户ID数组
      this.$refs.customerLabel.$show(userIds);
    },
    // 标签绑定成功回调
    handleLabelBindSuccess(data) {
      console.log('标签绑定成功:', data);
      this.$toast.success('标签绑定成功');

      // 清空选择
      this.resultCustomer = [];
      this.selectAll = false;
      this.checkMode = false;

      // 刷新当前列表
      this.userList = [];
      this.page = 1;
      this.finished = false;

      // 根据当前tab刷新对应列表
      if (this.actives === 0) {
        this.getContactIndex();
      } else if (this.actives === 1) {
        this.getPendingReviewList();
      } else if (this.actives === 2) {
        this.getBlackRoomList();
      } else if (this.actives === 3) {
        this.getRepeatList();
      }
    },
    userTagsChose(data) {
      const tagIds = data.map((i) => {
        return i.id;
      });
      const contactIds = this.resultCustomer.map((i) => i.id);
      const datas = {
        tagIds,
        contactIds,
      };
      batchCreateContactTag(datas).then((res) => {
        this.$message.success("操作成功");
        this.selectAll = [];
        this.checkMode = false;
      });
    },
    // 列表加载
    onLoad() {
      console.log("触发加载更多");
      if (this.actives === 2) {
        this.getBlackRoomList();
      } else if (this.actives === 1) {
        this.getPendingReviewList();
      } else if (this.actives === 3) {
        this.getRepeatList();
      } else {
        this.getContactIndex();
      }
    },
    gettiem() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // 注意：月份是 zero-based，所以需要加1
      const day = currentDate.getDate();
      return year + "-" + month + "-" + day;
    },
    gettiem1() {
      let currentDate = new Date();
      currentDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // 注意：月份是 zero-based，所以需要加1
      const day = currentDate.getDate();
      return year + "-" + month + "-" + day;
    },
    getContactIndex() {
      this.dataLiS.page = this.page;
      this.dataLiS.perPage = 10;
      this.dataLiS.name = this.serchVale;
      if (this.labelList.length != 0 && this.labelList[this.labelIndex].id != -1) {
        this.dataLiS.tag_id = this.labelList[this.labelIndex].id
      } else if (this.labelList.length != 0 && this.labelList[this.labelIndex].id == -1) {
        this.dataLiS.tag_id = ''
      }
      contactIndex(this.dataLiS).then((res) => {
        if (this.actives != 0) {
          return;
        }
        if (this.page == 1) {
          this.userList = [];
        }
        res.data.list.forEach((i) => {
          i.zk = false;
          i.tagsl = String(i.tags).length;
        });
        this.userList.push(...res.data.list);
        this.pages = res.data.page;
        if (
          res.data.list.length < 10 ||
          res.data.page.totalPage === this.page
        ) {
          this.finished = true;
          this.loading = true;
        } else {
          this.page++;
          this.finished = false;
          this.loading = false;
        }
      }).finally(() => {
        this.tabLoading = false;
        this.labelLoading = false;
      });
    },
    getBlackRoomList() {
      this.dataLiS.page = this.page;
      this.dataLiS.perPage = 10;
      blackRoomList({
        page: this.page,
        perPage: 10,
        name: this.serchVale,
      }).then((res) => {
        if (this.actives != 2) {
          return;
        }
        if (this.page == 1) {
          this.userList = [];
        }
        this.userList.push(...res.data.list);
        this.pages = res.data.page;
        if (
          res.data.list.length < 10 ||
          res.data.page.totalPage === this.page
        ) {
          this.finished = true;
          this.loading = true;
        } else {
          this.page++;
          this.finished = false;
          this.loading = false;
        }
      }).finally(() => {
        this.tabLoading = false;
      });
    },
    getPendingReviewList() {
      this.dataLiS.page = this.page;
      this.dataLiS.perPage = 10;
      pendingReviewList({
        page: this.page,
        perPage: 10,
        name: this.serchVale,
      }).then((res) => {
        if (this.actives != 1) {
          return;
        }
        if (this.page == 1) {
          this.userList = [];
        }
        this.userList.push(...res.data.list);
        this.pages = res.data.page;
        if (
          res.data.list.length < 10 ||
          res.data.page.totalPage === this.page
        ) {
          this.finished = true;
          this.loading = true;
        } else {
          this.page++;
          this.finished = false;
          this.loading = false;
        }
      }).finally(() => {
        this.tabLoading = false;
      });
    },
    getRepeatList() {
      this.dataLiS.page = this.page;
      this.dataLiS.perPage = 10;
      repeatList({
        page: this.page,
        perPage: 10,
        name: this.serchVale,
      }).then((res) => {
        if (this.page == 1) {
          this.heavyList = [];
        }
        this.heavyList.push(...res.data.list);
        this.heavyPage = res.data.page;
        if (res.data.list.length < 10) {
          this.finished = true;
          this.loading = true;
        } else {
          this.page++;
          this.finished = false;
          this.loading = false;
        }
      }).finally(() => {
        this.tabLoading = false;
      });
    },
    customerBase(e) {
      // workRoom({
      // 	name: e
      // }).then(res => {
      // 	this.baseList = res.data.list
      // })
    },
    search() {
      console.log(this.actives);
      console.log("123123");
      this.page = 1;
      this.onLoad();
      return
      if (this.actives === 0) {
        // this.dataLiS.page = this.page
        this.dataLiS.page = 1;
        this.dataLiS.perPage = 10;
        this.dataLiS.name = this.serchVale;
        if (this.serchVale) {
          this.serchT = true;
        }
        // this.serchT = true
        contactIndex(this.dataLiS).then((res) => {
          res.data.list.forEach((i) => {
            i.zk = false;
            i.tagsl = String(i.tags).length;
          });

          this.serListp = res.data.page;
          this.serList = res.data.list;
        });
      } else {
        this.customerBase(this.serchVale);
      }
    },
    clear() {
      if (this.actives === 0 || this.actives === 1 || this.actives === 2) {
        this.serchT = false;
      } else {
        this.customerBase();
      }
    },
    copy(i) {
      var clipboard = new Clipboard(".coopy");
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        //  释放内存
        clipboard.destroy();
      });
    },
    userDetails(e) { },
    async seeContactDetail(user_id) {
      console.log(user_id);
      await openEnterpriseChat("", user_id, "");

      // await openUserProfile(2, user_id)
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-tab {
  // color: #fff !important;
}

/deep/ .van-tabbar {
  box-sizing: content-box !important;
}

/deep/ .select .van-nav-bar__title {
  color: #fff !important;
}

/deep/ .select .van-field__body {
  color: #fff;
}

/deep/ .select .van-search {
  background: #245dc4;
  width: 100%;
  padding: 0 10px 0 0 !important;
}

/deep/ .select .van-search__content {
  //background: rgba(255, 255, 255, .3);
  background: #7c9fda;
  color: #fff;
}

/deep/ .select .van-icon-search {
  //color: #fff
  color: #000000;
}

.nav {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: var(--base-px-15);

  .nav-item {
    background: #e2e2e2;
    font-family: Source Han Sans;
    font-size: var(--base-px-12);
    font-weight: 350;
    color: #333333;
    padding: var(--base-px-6);
    margin-right: var(--base-px-10);
    border-radius: var(--base-px-6);
  }

  .nav-active {
    background: #1a89f9 !important;
    font-family: Source Han Sans;
    font-size: var(--base-px-12);
    font-weight: 350;
    color: #ffffff !important;
    padding: var(--base-px-6);
    margin-right: var(--base-px-10);
    border-radius: var(--base-px-6);
  }
}

.index {
  .tab {
    justify-content: space-between;
  }

  font-size: var(--base-px-14);
  height: 100%;
  background: #f1f2f5;
  overflow: auto;

  .audit-button {
    padding: var(--base-px-16) 0;
    background: #ffffff;
    border-top: var(--base-px-1) solid #dbdbdb;
  }

  p {
    margin: 0 !important;
  }

  .fs14 {
    opacity: 0.7;
    font-weight: 400;
    font-size: var(--base-px-14);
  }

  .fs16 {
    font-size: var(--base-px-12);
  }

  .fs12 {
    font-size: var(--base-px-12);
  }

  .fs24 {
    font-size: var(--base-px-24);
  }

  .select {
    display: flex;
    align-items: center;
    background: #245dc4;
    padding: var(--base-px-12) var(--base-px-16);
    box-sizing: border-box;
    color: #fff;
  }

  .bottom {
    .bottom-list {
      background: #fff;
      padding: 0 var(--base-px-5);
      font-size: var(--base-px-12);
      max-height: var(--base-px-30);
      overflow: hidden;
      padding-bottom: var(--base-px-10);

      div {
        background: #f7f7f7;
        border: var(--base-px-1) solid #e9e9e9;
        display: inline-block;
        padding: var(--base-px-2) var(--base-px-3);
        border-radius: var(--base-px-6);
        margin: 0px var(--base-px-5);
        margin-bottom: var(--base-px-7);
      }
    }

    .button {
      padding: 0px var(--base-px-12);
      background: #fff;
      padding-bottom: var(--base-px-5) !important;

      div {
        font-size: var(--base-px-13);
        color: #8db1db;
      }
    }

    .unset {
      max-height: unset;
    }

    border-radius: 0 0 var(--base-px-7) var(--base-px-7);
    overflow: hidden;
  }

  .customer {
    img {
      width: var(--base-px-22);
      height: var(--base-px-22);
    }

    padding: 10px var(--base-px-16);
    padding-bottom: var(--base-px-92);
  }

  .list {
    .choseItem {
      border: var(--base-px-1) solid #1890ff;
    }

    .list-item {
      background: #fff;
      padding: var(--base-px-10) var(--base-px-15);
      border-radius: var(--base-px-7);

      .mindel {
        flex: 1;
        margin-left: var(--base-px-15);
      }

      .avater {
        width: var(--base-px-50);
        height: var(--base-px-50);
        border-radius: var(--base-px-25);
      }

      .item {
        //margin-left: -87px;

        div:nth-child(1) {
          h4 {
            font-weight: bold;
            max-width: var(--base-px-168);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          span {
            color: #5ec75d;
            margin-left: var(--base-px-5);
          }
        }

        div:nth-child(2) {
          font-size: var(--base-px-12);
          color: #6a6a6a;

          div:nth-child(1) {
            display: flex;

            img {
              width: var(--base-px-20);
              height: var(--base-px-20);
              border-radius: 50%;
              margin-right: var(--base-px-5);
            }
          }
        }
      }

      .news {
        background: #e8f0ff;
        border-radius: 50%;
      }
    }
  }

  .groups {
    padding: 0 var(--base-px-16) var(--base-px-25);

    .group {
      margin-top: var(--base-px-10);
      background: #f9f9f9;
      padding: var(--base-px-13) var(--base-px-13) var(--base-px-6) var(--base-px-14);

      .info {
        padding-bottom: var(--base-px-13);
        border-bottom: var(--base-px-1) solid #f2f2f2;

        .col-1 {
          min-width: 0;
        }
      }

      .flex-row.justify-start {
        -webkit-box-align: start;
        align-items: flex-start;
      }

      .flex-row {
        -webkit-box-pack: start;
        -webkit-box-align: center;
        align-items: center;
        display: -webkit-box;
        display: flex;
        justify-content: flex-start;
        padding: 0;

        .col-1 {
          -webkit-box-flex: 1;
          flex: 1;

          .flex-row {
            -webkit-box-pack: start;
            -webkit-box-align: center;
            align-items: center;
            display: -webkit-box;
            display: flex;
            justify-content: flex-start;
            padding: 0;

            .flex-col {
              padding-left: var(--base-px-8);
              -webkit-box-flex: 1;
              flex: 1;
              min-width: 0;
              padding-right: var(--base-px-20);

              .flex-row {
                max-width: 100%;

                .bold {
                  font-size: var(--base-px-14);
                  font-weight: 600;
                  color: #333;
                  //line-height: 1.282125rem;
                  min-width: 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  word-break: break-all;
                  -webkit-box-flex: 1;
                  flex: 1;
                }

                span {
                  font-size: var(--base-px-14);
                  color: rgba(0, 0, 0, 0.45);
                }
              }

              .group-owner-text {
                font-size: var(--base-px-13);
                color: rgba(0, 0, 0, 0.3);

                .qw-open-data {
                  word-break: break-all;
                }
              }
            }

            .align-left {
              -webkit-box-align: start;
              align-items: flex-start;
            }

            img {
              width: var(--base-px-38);
              height: var(--base-px-38);
            }
          }
        }
      }

      .data {
        margin-top: var(--base-px-6);

        .col-1 {
          span {
            color: rgba(0, 0, 0, 0.65);
            font-size: var(--base-px-13);

            label {
              color: rgba(0, 0, 0, 0.45);
            }
          }

          span:last-child {
            margin-left: var(--base-px-18);
          }
        }

        .mark-tag-btn {
          background: #1890ff;
          border-radius: var(--base-px-4);
          font-size: var(--base-px-13);
          color: #fff;
          height: var(--base-px-25);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: var(--base-px-1) var(--base-px-8);
          display: inline-block;
          cursor: pointer;
          user-select: none;
        }
      }
    }
  }

  .select-all {
    position: fixed;
    display: flex;
    align-items: center;
    background: #fff;
    justify-content: space-between;

    .length {
      color: rgba(0, 0, 0, 0.45);
      margin-left: var(--base-px--90);
    }
  }

  .forbidden {
    font-weight: 500;
    font-size: var(--base-px-12);
    line-height: var(--base-px-16);
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .chat {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: var(--base-px-15);

    .chat-right {
      border-radius: var(--base-px-8);
      box-sizing: border-box;
      border: 0.5px solid #1A89F9;
      padding: var(--base-px-8) var(--base-px-18);
      font-family: Source Han Sans;
      font-size: var(--base-px-12);
      //font-weight: 350;
      color: #1A89F9;

      img {
        width: var(--base-px-20);
        height: var(--base-px-16);
        // margin-right:var(--base-px-4);
      }
    }
  }
}

.user-label {
  display: flex;
  align-items: center;
  gap: var(--base-px-10);
  margin-top: var(--base-px-10);

  .label-item {
    padding: var(--base-px-4) var(--base-px-8);
    border-radius: var(--base-px-4);
    border: solid 1px #919191;
    font-size: var(--base-px-12);
    color: #919191;
    cursor: pointer;
    user-select: none;
    min-width: fit-content;
  }

  .label-item-active {
    border: 1px solid #1890ff;
    color: #1890ff;
  }
}

.label-list {
  width: 100%;
  overflow-x: scroll;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* Internet Explorer 10+ */
}

.label-list::-webkit-scrollbar {
  display: none;
  /* Safari and Chrome */
}

.user-tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--base-px-6);
  margin-top: var(--base-px-8);
  width: 100%;
}

.tab-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--base-px-80) 0;
  min-height: 300px;
}
</style>
